export default __webpack_public_path__ + "static/arkadiuszs-b51e35fe52b097b0ee90d75278348f25.png";